import React from "react";
import { Image, Space, Tooltip, Typography } from "antd";
import { EyeInvisibleOutlined, FlagOutlined, SmileOutlined } from "@ant-design/icons";
import { Trans, useTranslation } from "react-i18next";
import GamePage from "./GamePage";

const { Paragraph, Text, Title } = Typography;
const cardImagesTrue = ["2.png", "3.png", "4.png", "5.png", "6.png", "7.png"];
const cardImagesLie = ["2.png", "6.png", "4.png", "king.png", "queen.png", "7.png"];

const LieingCards: React.FC = () => {
    const { t } = useTranslation();

    return (
        <GamePage
            game="lieingCards"
            tagColor="gold"
            instructionIcons={[
                <SmileOutlined key="deal" />,
                <EyeInvisibleOutlined key="declare" />,
                <FlagOutlined key="challenge" />,
                <span key="drink" aria-hidden="true">🍻</span>,
            ]}
        >
            <section aria-labelledby="lieing-cards-example-title">
                <Title level={2} id="lieing-cards-example-title">{t("games.details.lieingCards.exampleTitle")}</Title>
                <Paragraph type="secondary">{t("games.details.lieingCards.honestExample")}</Paragraph>
                <Space wrap size={8}>
                    {cardImagesTrue.map((img) => (
                        <Image
                            width={44}
                            preview={false}
                            key={img}
                            src={process.env.PUBLIC_URL + `/cards/${img}`}
                            alt={img.replace(".png", "")}
                            style={{ borderRadius: 4 }}
                        />
                    ))}
                    <Text type="secondary">…</Text>
                </Space>
                <Paragraph type="secondary" style={{ margin: "20px 0 6px" }}>
                    {t("games.details.lieingCards.lieExample")}
                </Paragraph>
                <Space wrap size={8}>
                    {cardImagesLie.map((img) => (
                        <Image
                            width={44}
                            preview={false}
                            key={img}
                            src={process.env.PUBLIC_URL + `/cards/${img}`}
                            alt={img.replace(".png", "")}
                            style={{ borderRadius: 4 }}
                        />
                    ))}
                    <Text type="secondary">…</Text>
                </Space>
                <Paragraph type="secondary" style={{ marginTop: 20 }}>
                    <Tooltip
                        title={
                            <Trans
                                i18nKey="games.details.lieingCards.tooltip"
                                components={{ code: <Text code key="tooltip-code" /> }}
                            />
                        }
                    >
                        <Trans
                            i18nKey="games.details.lieingCards.tooltipTrigger"
                            components={{ code: <Text code key="trigger-code" /> }}
                        />
                    </Tooltip>
                </Paragraph>
            </section>
        </GamePage>
    );
};

export default LieingCards;
